import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Link, Tooltip, Box, CircularProgress,
  Typography,
  SvgIcon
} from '@material-ui/core';
import useGetRequest from '../../hooks/useGetRequest';
import { Engagement, EngagementWithWorkflow } from '../../types';


const EngagementSummary = ({
  engagementId
}: any) => {
  const {
    result: engagement,
    isLoading,
    setResult: setEngagement,
  } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/`,
  });

  let content;
  if (isLoading) {
    content = <CircularProgress size={20} />;
  } else {
    content = (
      <Box>
        <Box display="flex">
          <Typography variant="h6">
            {engagement.workflow.name}:&nbsp;
          </Typography>
          <Typography variant="body2">
            #{engagement.name}
          </Typography>
        </Box>
        <Box pb={1} display="flex">
          <Typography variant="h6">
            Current step:&nbsp;
          </Typography>
          <Typography variant="body2">
            {engagement.stepName}
          </Typography>
        </Box>
        {
          engagement.roleAssignments.map((ra: any) => (
            <Box display="flex">
              <Typography variant="h6">
                {ra.role.name}:&nbsp;
              </Typography>
              <Typography variant="body2">
                {`${ra.account.firstName} ${ra.account.lastName}`}
              </Typography>
            </Box>
          ))
        }
      </Box>
    );
  }

  return (
    <Box p={1}>
      {content}
    </Box>
  );
};

const EngagementNameCell = ({
  engagement
}: { engagement: (Engagement | EngagementWithWorkflow)}) => (
  <Tooltip title={<EngagementSummary engagementId={engagement.id} />} placement="right">
    <Link
      variant="h6"
      color="inherit"
      to={`/engagements/${engagement.id}`}
      component={RouterLink}
    >
      {
        engagement.workflow ? `${engagement.workflow.name}: #${engagement.name}` : `#${engagement.name}`
      }
    </Link>
  </Tooltip>
);

export default EngagementNameCell;
